const resourcePrefix = 'images/'

export const ImageResource = {
    startBackground: `${resourcePrefix}/herobanner_desktop.jpg`,
    startBackgroundMobile: `${resourcePrefix}/herobanner_mobile_2.jpg`,
    logo: `${resourcePrefix}/logo.png`,
    laptop: `${resourcePrefix}/laptop_icon.svg`,
    // laptop: `${resourcePrefix}/laptop.png`,
    laptopContent: `${resourcePrefix}/laptop_content.jpg`,
    uncleOnWedding: `${resourcePrefix}/uncle_on_a_wedding.svg`,
    rockingAunt: `${resourcePrefix}/rocking_aunt.svg`,
    facebookIcon: `${resourcePrefix}/facebook.svg`,
    instagramIcon: `${resourcePrefix}/instagram.svg`,
    whatsAppIcon: `${resourcePrefix}/whatsapp.svg`,
    contactBackground: `${resourcePrefix}/contact_bg.png`,
}